module.exports = __webpack_public_path__ + "img/arrow_r.2cace1ca.svg";